import { withSnapshotVersion } from '@sb/database/snapshotParams';
import type { GlobalSpaceData } from '@sb/feathers-types';
import { makeNamespacedLog } from '@sb/log';
import { Space } from '@sb/routine-runner';

const log = makeNamespacedLog('convertGlobalSpaceResponse');

export function convertGlobalSpaceResponse(globalSpaceData: GlobalSpaceData): {
  globalSpaceID: string;
  spaceItem: Space.Item;
} | null {
  // Apply migration for backward compatibility
  const migratedItem = Space.migratePalletBoxesData(globalSpaceData.spaceItem);
  const parsedItem = Space.Item.safeParse(migratedItem);

  if (parsedItem.success) {
    const spaceItem = withSnapshotVersion(
      parsedItem.data,
      globalSpaceData.updated,
    );

    return { globalSpaceID: globalSpaceData.id, spaceItem };
  }

  log.warn('GlobalSpace', 'Failed to parse item', globalSpaceData.spaceItem);

  return null;
}
